import React, { useMemo } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "ui/components/card";
import { assetUrl } from "utils/index";
import MediaGallery from "components-v2/image-gallery";

export default function TicketAttachments({ attachments }) {
  const normalized = useMemo(() => {
    const list = Array.isArray(attachments) ? attachments : [];
    return list
      .map((item) => item?.attachment)
      .filter(Boolean)
      .map((att) => ({
        id: att.id,
        type: att.type || "",
        filename: att.filename_download || att.title || att.id,
        url: assetUrl(att.id),
      }));
  }, [attachments]);

  const media = useMemo(
    () =>
      normalized
        .filter((a) => a.type.startsWith("image/") || a.type.startsWith("video/"))
        .map((a) => ({ url: a.url, type: a.type, filename: a.filename })),
    [normalized]
  );

  const other = useMemo(
    () => normalized.filter((a) => !a.type.startsWith("image/") && !a.type.startsWith("video/")),
    [normalized]
  );

  if (normalized.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          Attachments ({normalized.length})
        </CardTitle>
      </CardHeader>

      <CardContent className="space-y-6">
        {/* Images & Videos */}
        {media.length > 0 && (
          <section>
            <MediaGallery items={media} />
          </section>
        )}

        {/* Other files */}
        {other.length > 0 && (
          <section className="space-y-3">
            <div className="text-sm font-medium">Files ({other.length})</div>
            <div className="space-y-2">
              {other.map((f) => (
                <a
                  key={f.id}
                  href={f.url}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center justify-between gap-3 rounded-lg border bg-background px-3 py-2 text-sm hover:bg-muted"
                >
                  <span className="truncate">{f.filename || f.id}</span>
                  <span className="shrink-0 text-muted-foreground">Download</span>
                </a>
              ))}
            </div>
          </section>
        )}
      </CardContent>
    </Card>
  );
}
